const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/eCheckin/sections/Abschluss.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import textMap from '../translations';
import { Link, LinksBlock } from 'App/components/eCheckin/components/fields/LinksBlock';
import Divider from '@mui/material/Divider';
import { useText } from '@cistec/common_web/utils/intlUtils';

const termsAndConditionsLinks: Link[] = [
    {
        name: 'allgemeineGeschaftsbedingungen',
        text: textMap.termsAndConditions,
        href: 'https://www.solothurnerspitaeler.ch/fileadmin/Broschueren_Flyer/soH_AGB_2026.pdf',
    },
];

export const Abschluss = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const { formatMessage } = useIntl();
    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <p>{formatMessage(textMap.eCheckinCompletion)}</p>
            <Divider />
            <LinksBlock links={termsAndConditionsLinks} basePath={path} required={true} />
        </ECheckinSection>
    );
});

Abschluss.displayName = 'Abschluss';

export default Abschluss;
